/** Returns an absolute HTTP(S) URL unchanged, or undefined for invalid and unsafe URLs. */
export function parseValidHttpUrl(raw: string | null | undefined): string | undefined {
  if (!raw) return undefined;
  try {
    const url = new URL(raw);
    if (url.protocol === "http:" || url.protocol === "https:") {
      return raw;
    }
  } catch {
    // Invalid or non-absolute URL format.
  }
  return undefined;
}
